import React from 'react';
import { Framework } from '@/pages/layouts';
import CourseContainer from '@/containers/course-detail';

const Course = () => {
  return (
    <Framework>
      <CourseContainer />
    </Framework>
  );
};

export default Course;
